import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IJourneyTabChangeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/journeyTabChangeActionParams";

class JourneyTabChangeAction extends BaseAction<void, IJourneyTabChangeActionParams> {
  override async run(): Promise<void> {
    const { value } = this.params!;

    if (Object.values(TripTypeEnum).includes(value)) {
      updateRecoilState("journeyPlannerTrainTypeTabAtom", value);
    }
  }
}

export const journeyTabChangeAction = new JourneyTabChangeAction();
